module.exports = __webpack_public_path__ + "781ba52a545ee2a0d30b7929f652a127.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/adelle_bold-webfont.ttf
// module id = 225
// module chunks = 0